module.exports = __webpack_public_path__ + "4ad2a1ccf8798981da0a2f46a293f7ec.png";